import React, { useEffect } from 'react';
import ModelTitle from "./ModelTitle";
import ModelFooter from "./ModelFooter";
const Model = props => {
    var _a, _b, _c;
    const modalClasses = props.classes && (((_a = props.classes) === null || _a === void 0 ? void 0 : _a.modal) || '');
    const modalDialog = props.classes && (((_b = props.classes) === null || _b === void 0 ? void 0 : _b.modalDialog) || '');
    const modalBody = props.classes && (((_c = props.classes) === null || _c === void 0 ? void 0 : _c.modalBody) || '');
    useEffect(() => {
        document.body.classList.add(`overflow-hidden`);
        return () => {
            document.body.classList.remove(`overflow-hidden`);
        };
    }, []);
    return (React.createElement("div", { className: `c_modal ${modalClasses}` },
        React.createElement("div", { className: `c_modal-dialog ${modalDialog}`, role: "document" },
            React.createElement("div", { className: "c_modal-content" },
                React.createElement("div", { className: "c_modal-header" },
                    props.title && React.createElement(ModelTitle, { title: props.title }),
                    props.onClose &&
                        React.createElement("span", { "data-dismiss": "modal", "aria-label": "Close", onClick: props.onClose, className: 'hoverPointer' },
                            React.createElement("svg", { width: "24", height: "24", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", className: "mh-50px" },
                                React.createElement("rect", { opacity: "0.5", x: "6", y: "17.3137", width: "16", height: "2", rx: "1", transform: "rotate(-45 6 17.3137)", fill: "currentColor" }),
                                React.createElement("rect", { x: "7.41422", y: "6", width: "16", height: "2", rx: "1", transform: "rotate(45 7.41422 6)", fill: "currentColor" })))),
                React.createElement("div", { className: `c_modal-body` }, props.children),
                props.footer && React.createElement(ModelFooter, null, props.footer)))));
};
export default Model;
